import { CREDENTIAL_FACTORY } from '../factories/CredentialFactory'
import { SESSION_SERVICE } from '../services/SessionService'
import { CLIENT_FACTORY } from '../factories/ClientFactory'
import { SESClient, SendEmailCommand, SendRawEmailCommand, SendRawEmailCommandInput } from '@aws-sdk/client-ses'
import { Credentials } from '@aws-sdk/client-sts'
import { Email } from '../constants/Email'
import { createMimeMessage } from 'mimetext/browser'
// import { User } from '../models/User'

const SESSION = SESSION_SERVICE.getCurrentSession()
// const USER = SESSION.user as User

let credentials: Credentials | undefined
let client: SESClient | undefined

function getUnixEpoch(date: Date) {return date ? Math.floor(date.getTime() / 1000) : 0}

export async function sendSESEmail(from: string, to: string, subject: string, text: string, html?: string) {
  credentials = await getCachedCredentials()
  if (!client) client = CLIENT_FACTORY.getSESClient(credentials!)
  const response = await client.send(getSendEmailCommand(from, to, subject, text, html))
  const statusCode = response.$metadata.httpStatusCode

  if (statusCode !== 200) {
    throw Error(`Unable to send email, the HTTP status code is ${statusCode}.`)
  }

  console.log(`The notification with message ID ${response.MessageId} has been sent.`)
  return response.MessageId
}

export async function sendSESRawEmail(request: SendRawEmailCommandInput) {
  try {
    credentials = await getCachedCredentials()
    if (!client) client = CLIENT_FACTORY.getSESClient(credentials!)
    const command = new SendRawEmailCommand(request);
    const response = await client.send(command);
    const statusCode = response.$metadata.httpStatusCode

    if (statusCode !== 200) return `ERROR: Unable to send email. the HTTP status code is ${statusCode}.`
  } catch (error) {
    console.error('Error sending email (sendSESRawEmail):', error);
    return `ERROR: Unable to send email. ${error instanceof Error ? error.message : 'Unknown error'}`
  }

  return ""
}


function getSendEmailCommand(from: string, to: string, subject: string, text: string, html?: string): SendEmailCommand {
  return new SendEmailCommand({
    Destination: {
      ToAddresses: [
        to
      ]
    },
    Message: {
      Body: {
        Text: { Charset: Email.UTF8, Data: text },
        Html: { Charset: Email.UTF8, Data: html },
      },
      Subject: {
        Charset: Email.UTF8,
        Data: subject
      }
    },
    Source: from,
  })
}

async function getCachedCredentials(): Promise<Credentials | undefined> {
  const credsEpoch = credentials && credentials.Expiration ? getUnixEpoch(credentials.Expiration) : 0
  const nowEpoch = getUnixEpoch(new Date())
  const expired = credsEpoch < nowEpoch

  if (!credentials || expired) {
    credentials = await CREDENTIAL_FACTORY.assumeRole()
    console.log('Refreshed the notification roles credentials')
  }

  return credentials
}

export const createEmailWithAttachmentsRequest = (
  from: string,
  to: string,
  cc: string,
  bcc: string,
  subject: string,
  textBody = '',
  htmlBody ?: string,
  attachments?: { contentType: string, fileName: string, base64: string }[]
): SendRawEmailCommandInput => {
  const tos = to.split(';').map(item => item.trim()).filter(item => item.length > 0)
  const encoder = new TextEncoder()
  const msg = createMimeMessage()
  msg.setSender({ addr: from })
  msg.setRecipient(tos)
  if (cc)  msg.setCc(cc.split(';').map(item => item.trim()).filter(item => item.length > 0))
  if (bcc) msg.setBcc(bcc.split(';').map(item => item.trim()).filter(item => item.length > 0))
  msg.setSubject(subject)
  //Add this when we need to debug an email issue. It sends email events to a queue.
  //msg.setHeader('X-SES-CONFIGURATION-SET', 'Test')

  if (textBody) msg.addMessage({
    contentType: 'text/plain',
    data: textBody
  });

  if (htmlBody) msg.addMessage({
    contentType: 'text/html',
    data: htmlBody
  });

  for (const a of attachments || []) {
    msg.addAttachment({
      filename: a.fileName,
      contentType: a.contentType,
      data: a.base64
    })
  }

  // Craft the MIME message
  const raw = msg.asRaw()
  // Convert raw message text to Uint8Array
  const rawMessage = encoder.encode(msg.asRaw());

  return {
      Source: from,
      Destinations: tos,
      RawMessage: { Data: rawMessage }
  }
}

export async function sendSESEmailWithAttachments(from: string, to: string, cc: string, bcc: string, subject: string, text: string, html?: string, attachments?: { contentType: string, fileName: string, base64: string }[]) {
  try {
    const request = createEmailWithAttachmentsRequest(from, to, cc, bcc, subject, text, html, attachments)
    const result = await sendSESRawEmail(request)
    return result
  } catch (error) {
    console.error('Error sending email with attachment:', error);
    return `Unable to send email. ${error instanceof Error ? error.message : 'Unknown error'}`
  }
}
/*

// Multiple recipients (array of objects)
msg.setCc([
    { name: 'CC Person 1', addr: 'cc1@example.com' },
    { name: 'CC Person 2', addr: 'cc2@example.com' }
]);

// "To" by default
msg.setRecipient('Firstname Lastname <first@last.com>')
// but you can still specify other kinds
msg.setRecipient('Firstname Lastname <first@last.com>', {type: 'Cc'})
// all as object
msg.setRecipient({
    addr: 'first@last.com', 
    name: 'Firstname Lastname', 
    type: 'Bcc'
})

       // using an inline attachment id here:
        '<img src="cid:dots123456"><br><br>' +

// and the inline attachment:
msg.addAttachment({
    inline: true,
    filename: 'dots.jpg',
    contentType: 'image/jpg',
    data: '...base64 encoded data...',
    headers: {'Content-ID': 'dots123456'}
})

// two more attachments but they aren't inlined, they are attached
msg.addAttachment({
    filename: 'sample.jpg',
    contentType: 'image/jpg',
    data: '...base64 encoded data...'
})
msg.addAttachment({
    filename: 'sample.txt',
    contentType: 'text/plain',
    data: '...base64 encoded data...'
})


*/